import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import { IconButton, Tooltip, Button, CircularProgress } from "@mui/material";
import { MdDescription, MdDelete } from "react-icons/md";
import Swal from "sweetalert2";
import { descargarDocumento } from "../Seguridad/DescargarDocumento";

function DescripcionPerfil(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [list, setList] = useState([]);
  const [list1, setList1] = useState([]);
  const [list2, setList2] = useState([]);

  const handleOpenModalTest = () => {
    setIsOpen(true);
    setLoading(true);
  };

  const closeModal = () => setIsOpen(false);

  // Cargar toda la data cuando el modal abra
  useEffect(() => {
    if (modalIsOpen) {
      obtenerTodo();
    }
  }, [modalIsOpen]);

  const obtenerTodo = async () => {
    try {
      setLoading(true);

      const auth = {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      };

      const req1 = axios.get(
        "https://suadesarrollo.azurewebsites.net/api/ObtenerPerfil/" +
          props.idRegistro,
        { auth },
      );

      const req2 = axios.get(
        "https://suadesarrollo.azurewebsites.net/api/ObtenerPerfilAutoevaluacion/" +
          props.InstitucionID,
        { auth },
      );

      const req3 = axios.get(
        "https://suadesarrollo.azurewebsites.net/api/ObtenerAdjuntoAutoEvaluacion?SolicitudId=" +
          props.InstitucionID +
          "&SubtituloId=" +
          props.subtitulosId,
        { auth },
      );

      const [res1, res2, res3] = await Promise.all([req1, req2, req3]);

      setList(res1.data);
      setList1(res2.data);
      setList2(res3.data);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "No se pudo cargar la información", "error");
    } finally {
      setLoading(false);
    }
  };

  // Eliminar adjunto
  const eliminarAdjunto = (id) => {
    Swal.fire({
      title: "¿Eliminar adjunto?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      zIndex: 999999,
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(
            "https://suadesarrollo.azurewebsites.net/api/EliminaAdjuntoAutoEvaluacion?id=" +
              id,
            {
              auth: {
                username: "BasicAuth@icontec.org",
                password: "yQLzqmR7eZSuAmQZUqhY",
              },
            },
          )
          .then(() => {
            Swal.fire(
              "Eliminado",
              "El adjunto fue eliminado correctamente.",
              "success",
            );
            obtenerTodo(); // refrescar todo
          })
          .catch((error) => {
            Swal.fire("Error", "No se pudo eliminar el adjunto.", "error");
            console.error(error);
          });
      }
    });
  };

  return (
    <div>
      <Tooltip title="Descripción">
        <IconButton color="info" onClick={handleOpenModalTest}>
          <MdDescription />
        </IconButton>
      </Tooltip>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Descripción del Perfil"
        style={{
          overlay: { zIndex: 1050 },
          content: { zIndex: 1060 },
        }}
      >
        {loading ? (
          <div className="text-center my-5">
            <CircularProgress />
            <p className="mt-3">Cargando información...</p>
          </div>
        ) : (
          <div className="container">
            <div className="text-center">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Información Autoevaluación {props.idInstitucion},{" "}
                    {props.subtitulosId}
                  </h6>
                </div>

                <div className="card-body">
                  <div className="table-responsive">
                    <table
                      className="table table-bordered"
                      width="100%"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Descripción</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.map((item) => (
                          <tr key={item.id}>
                            <td>{item.descripcion}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    <h6 className="mt-4 mb-2">Archivos Adjuntos</h6>

                    <table className="table table-sm table-striped">
                      <thead>
                        <tr>
                          <th>Archivo</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list2.map((item) => (
                          <tr key={item.id}>
                            <td>
                              {item.urlUbicacion ? (
                                <button
                                  className="btn btn-success"
                                  onClick={() =>
                                    descargarDocumento(item.urlUbicacion)
                                  }
                                >
                                  Descargar Adjunto
                                </button>
                              ) : (
                                "Sin archivo"
                              )}
                            </td>
                            <td>
                              <Tooltip title="Eliminar adjunto">
                                <IconButton
                                  color="error"
                                  onClick={() => eliminarAdjunto(item.id)}
                                >
                                  <MdDelete />
                                </IconButton>
                              </Tooltip>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={closeModal}
                    >
                      Cerrar
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </ReactModal>
    </div>
  );
}

export default DescripcionPerfil;
